<section class="sections-editor">
  <div class="chart-row">
    <ng-content select="[chartAside]" />
    <div class="chart-column">
      <ng-content select="[chartHeader]" />
      <div class="chart-wrapper">
        <app-section-chart
          [disabled]="disabled()"
          [(sections)]="sections"
          (createSection)="createNewSection()"
          (duplicateSections)="duplicateSelectionOfSections()"
          [mode]="workoutMode()"
          (sectionChangeStart)="startSectionChange()"
          (sectionChange)="applySectionChange($event.sectionId, $event.change)"
          (sectionChangeEnd)="endSectionChange()"
        />
      </div>
    </div>
  </div>
  <ul class="data">
    <li class="duration" [style.grid-row]="'span ' + dataStats().length">
      <h4>{{ totalDuration() }}</h4>
      <label>
        <kin-icon [color]="colorService.neutral500()" name="timer" />
        <p>{{ 'sections_editor.duration' | translate }}</p>
      </label>
    </li>
    @for (stat of dataStats(); track stat.type) {
      @for (metric of dataStatMetrics; track metric.key) {
        <li>
          <h4>{{ formatDataStat(stat[metric.key], stat.type) }}</h4>
          <label>
            <kin-icon
              [color]="colorService.neutral500()"
              [name]="sectionEditorService.getWorkoutModeIcon(stat.type)"
            />
            <p>
              {{ workoutMode() ? sectionEditorService.getWorkoutModeLabel(stat.type) : '-' }}
              {{ metric.label | translate }}
            </p>
          </label>
        </li>
      }
    }
  </ul>
</section>
<h3>{{ 'sections_editor.segments' | translate }}</h3>
<div class="field-group segments-group">
  <ul class="segments-container" cdkDropList (cdkDropListDropped)="drop($event)">
    @if (sections().length === 0) {
      <p>{{ 'sections_editor.empty' | translate }}</p>
    } @else {
      @for (section of sections(); track section.id) {
        <li>
          <app-section-row
            [section]="section"
            dragBoundaryClass=".segments-container"
            (delete)="deleteSection(section)"
            (sectionChange)="applySectionChange(section.id, $event)"
            (duplicate)="duplicateSection($event)"
            [mode]="workoutMode()"
          />
        </li>
      }
    }
  </ul>
  @if (errorMessage()) {
    <p class="field-error">{{ errorMessage() }}</p>
  }
</div>

<!-- TOOLBAR -->
@if (selectedSections().length) {
  <app-section-editor-toolbar
    [sections]="selectedSections()"
    (sectionChange)="applySectionChange(selectedSections()[0].id, $event)"
    (duplicate)="duplicateSelectionOfSections()"
    (delete)="deleteSelectedSections()"
    (move)="moveSelection($event)"
  />
}
